import { ComponentType, PropsWithChildren, useEffect, useRef } from 'react';
import * as S from './styles';
import { IconButtonProps } from '@/components/atoms/IconButton';
import { CSSProperties } from 'styled-components';

export type Tamanho = {
  width: number;
  height: number;
};

export type DrawerProps = PropsWithChildren<{
  style?: CSSProperties;
  $TriggerButton?: ComponentType<IconButtonProps>;
  // eslint-disable-next-line no-unused-vars
  lidarMudancaTamanho?: (tamanho: Tamanho) => void;
}>;

export default function Drawer(props: DrawerProps) {
  const { style, children, lidarMudancaTamanho } = props;
  const drawerRef = useRef(null);

  useEffect(() => {
    const mudancaValorTamanho = () => {
      if (drawerRef?.current) {
        const { offsetWidth, offsetHeight } = drawerRef.current;
        const newSize = { width: offsetWidth, height: offsetHeight };
        if (lidarMudancaTamanho) {
          lidarMudancaTamanho(newSize);
        }
      }
    };

    const mudancaTamanhoObserver = new ResizeObserver(mudancaValorTamanho);
    if (drawerRef?.current) {
      mudancaTamanhoObserver.observe(drawerRef?.current);
    }

    return () => {
      mudancaTamanhoObserver.disconnect();
    };
  }, [lidarMudancaTamanho]);

  return (
    <S.Container ref={drawerRef} style={style}>
      {children}
    </S.Container>
  );
}
